import gql from 'graphql-tag';

export const GET_ALERT = gql`
  query getAlert($id: ID!) {
    alert(id: $id) {
      id
      active
      createdAt
      email
      filter
      notifEmail
      notifMobile
      querystring
      title
      total
      uid
    }
  }
`;

export const GET_ALERTS = gql`
  query getAlerts($LIMIT: Int, $page: Int, $uid: String) {
    alerts(limit: $LIMIT, page: $page, uid: $uid) {
      data {
        id
        active
        createdAt
        email
        filter
        notifEmail
        notifMobile
        querystring
        title
        posts(limit: 4) {
          total
        }
        uid
      }
      total
    }
  }
`;

export const COUNT_ALERTS = gql`
  query countAlerts($uid: String) {
    countAlerts(uid: $uid) {
      total
    }
  }
`;
